import { render } from "./banner-suscription.vue?vue&type=template&id=2b07226f&scoped=true&lang=html"
import script from "./banner-suscription.vue?vue&type=script&lang=js"
export * from "./banner-suscription.vue?vue&type=script&lang=js"

import "./banner-suscription.vue?vue&type=style&index=0&id=2b07226f&scoped=true&lang=scss"

import exportComponent from "/build/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2b07226f"]])

export default __exports__